"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Location = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _PlacesInput = _interopRequireDefault(require("../PlacesInput"));

var _RadiusSlider = require("../RadiusSlider");

var _ie11Check = require("@jobmatchme/utils/es/ie11Check");

var _isWindow = require("@jobmatchme/utils/es/isWindow");

var _useOurTranslation = require("../../utils/useOurTranslation");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _reactPlacesAutocomplete = require("react-places-autocomplete");

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _Optimizers = require("../../utils/Optimizers");

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * location component for whitelabel funnel
 * @config {object} our funnel config
 * @context {react context} the funnel context
 */
var LocationComponent = function LocationComponent(_ref) {
  var _config$educationTool;

  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var _useState = (0, _react.useState)(context[config.valueName].value.name),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      address = _useState2[0],
      handlePlacesChange = _useState2[1];

  var touched = (0, _ProfileProvider.isTouched)(context[config.valueName]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      openPlacesDialog = _useState4[0],
      setOpenPlacesDialog = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      lastResult = _useState6[0],
      setLastResult = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      addressChanged = _useState8[0],
      setAddressChanged = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      showMandatoryAlert = _useState10[0],
      setShowMandatoryAlert = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      showAddressHint = _useState12[0],
      setShowAddressHint = _useState12[1];

  var visibleFor = config.educationTooltip && config.educationTooltip.visibleFor;
  var cleanAddress = (0, _react.useCallback)(function () {
    // erase in profileProvider
    if (lastResult === '' || addressChanged === false || lastResult !== address) {
      handlePlacesChange(lastResult !== '' ? lastResult : '');
    }
  }, [lastResult, addressChanged, address]);
  (0, _react.useEffect)(function () {
    if (address && address.length > 0) {
      setShowMandatoryAlert(false);
    } else if (address === '' && touched) {
      setShowMandatoryAlert(true);
    }
  }, [address, touched]);

  var handleOnFocus = function handleOnFocus() {
    // open places dialog with input component
    if (_isWindow.isWindow) {
      setOpenPlacesDialog(true);
      setTimeout(function () {
        var placesPlainInput = document.getElementById('dialogPlacesInput');
        placesPlainInput.focus();
      }, 250);
    }
  };

  var hideKeyboard = function hideKeyboard() {
    if (_isWindow.isWindow) {
      setTimeout(function () {
        document.activeElement.blur();
      }, 100);
    }
  };

  var handlePlacesSelect = function handlePlacesSelect(address) {
    (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
      return handleAddress(results);
    }).catch(function (error) {
      return console.error('Error', error);
    });
    hideKeyboard();
  };

  var handleAddress = function handleAddress(results) {
    if (typeof results[0] === 'undefined') {
      return;
    }

    var address = results[0].formatted_address;

    if ((results[0].types.includes('country') || results[0].types.includes('continent')) && !showAddressHint) {
      cleanAddress();
      setShowAddressHint(true);
    } else {
      (0, _reactPlacesAutocomplete.getLatLng)(results[0]).then(function (latLng) {
        // write to profileProvider
        setValue(config.valueName, {
          latitude: latLng.lat.toString(),
          longitude: latLng.lng.toString(),
          name: address
        }); // close places dialog

        setOpenPlacesDialog(false);
        setLastResult(address);
        setAddressChanged(true);
        handlePlacesChange(address);
        setShowAddressHint(false);
      });
    }
  };

  var handleClose = function handleClose() {
    if (address === '' || touched === false || address !== lastResult) {
      // Set red border color by Input Field
      setShowMandatoryAlert(true); // Clear input field and profileProvider

      cleanAddress();
    }

    setAddressChanged(false);
    setOpenPlacesDialog(false);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
      fullScreen: true,
      fullWidth: !_ie11Check.isIE11,
      open: openPlacesDialog,
      onClose: handleClose,
      "aria-labelledby": "form-dialog-title",
      className: "".concat(!_ie11Check.isIE11 ? _styleModule.default.dialogPlacer : ''),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        className: "".concat(_styleModule.default.placeInput, " ").concat(_ie11Check.isIE11 ? _styleModule.default.ie11 : ''),
        children: [showAddressHint && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
          small: true,
          headline: t('common.location.whichCity')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlacesInput.default, {
          t: t,
          location: address,
          id: 'dialogPlacesInput',
          inputText: t(config.translations.inputText),
          handlePlacesChange: handlePlacesChange,
          handlePlacesSelect: handlePlacesSelect,
          cleanAddress: cleanAddress,
          touched: touched
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogActions.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Clear.default, {
          onClick: handleClose,
          className: _styleModule.default.placeInputClose
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.location,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        id: "introText",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
          headline: t(config.translations.text),
          text: t(config.translations.hint),
          toolTipVisible: visibleFor
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: "".concat((0, _Onboarding.targetClassName)((_config$educationTool = config.educationTooltip) === null || _config$educationTool === void 0 ? void 0 : _config$educationTool.target)),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlacesInput.default, {
          t: t,
          location: address,
          inputText: t(config.translations.inputText),
          handlePlacesChange: handlePlacesChange,
          handlePlacesSelect: handlePlacesSelect,
          handleOnFocus: handleOnFocus,
          showMandatoryAlert: config.mandatory && showMandatoryAlert,
          touched: touched
        })
      }), (touched || config.isSingleView) && config.withRadius && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadiusSlider.RadiusSlider, {
          config: config,
          setValue: setValue,
          context: context
        })
      })]
    })]
  }, 'location');
};

var LocationWrapper = (0, _Optimizers.memoizeComponentByValue)(LocationComponent);

var Location = function Location(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LocationWrapper, {
    config: config,
    context: context
  });
};

exports.Location = Location;